import React from 'react';
import {useFormContext} from "react-hook-form";
import Grid from "@mui/material/Grid";
import {QuestionWithMultipleOption} from "../../../../widgets/inputs/QuestionWithMultipleOption";
import {Divider, Typography} from "@mui/material";
import {amber, green, purple, red} from "@mui/material/colors";
import {useForceUpdate} from "../../../../widgets/utils/useForceUpdate";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";

export function calcPunteggioQuarantenaBoolean(data) {
	let result = 0;
	if (data["tosse"]) result += 1;
	if (data["malDiGola"]) result += 1;
	if (data["dispnea"]) result += 1;
	if (data["cefalea"]) result += 1;
	if (data["alterazioneGusto"]) result += 1;
	if (data["alterazioneOlfatto"]) result += 1;
	if (data["brividi"]) result += 1;
	if (data["mialgia"]) result += 1;
	if (data["inappetenza"]) result += 1;
	if (data["vomito"]) result += 1;
	if (data["diarrea"]) result += 1;
	if (data["raffreddore"]) result += 1;
	
	return result;
}

export function calcPunteggioQuarantena(data) {
	let result = 0;
	if (data["tosse"] && data["tosse"] === "true") result += 1;
	if (data["malDiGola"] && data["malDiGola"] === "true") result += 1;
	if (data["dispnea"] && data["dispnea"] === "true") result += 1;
	if (data["cefalea"] && data["cefalea"] === "true") result += 1;
	if (data["alterazioneGusto"] && data["alterazioneGusto"] === "true") result += 1;
	if (data["alterazioneOlfatto"] && data["alterazioneOlfatto"] === "true") result += 1;
	if (data["brividi"] && data["brividi"] === "true") result += 1;
	if (data["mialgia"] && data["mialgia"] === "true") result += 1;
	if (data["inappetenza"] && data["inappetenza"] === "true") result += 1;
	if (data["vomito"] && data["vomito"] === "true") result += 1;
	if (data["diarrea"] && data["diarrea"] === "true") result += 1;
	if (data["raffreddore"] && data["raffreddore"] === "true") result += 1;
	
	return result;
}

export const MonitoraggioQuarantenaGrid = ({paziente = false}) => {
	const {errors, control, getValues} = useFormContext();
	const forceUpdate = useForceUpdate();
	const classes = BaseStyle();
	
	return (
		<React.Fragment>
			<Grid container spacing={3} className={classes.monitoraggioContainer} onClick={forceUpdate}>
				
				<Grid item xs={12}>
					<Typography color={"primary"} variant={"subtitle1"} style={{fontSize: 22}}>
						<b>Domande di carattere generale</b>
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"1. Presenta tosse?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"tosse"}
						error={errors["tosse"]}
						answers={[
							{
								label: "Tosse frequente",
								value: "true",
								info: paziente ? "Ho più di 10 colpi di tosse al giorno" : "> di 10 colpi al giorno"
							},
							{
								label: "Tosse sporadica",
								value: "0",
								info: paziente ? "Ho meno di 10 colpi di tosse al giorno" : "<= di 10 colpi al giorno"
							},
							{label: "Tosse assente", value: "A", info: paziente ? "Non ho tosse" : "non presente"},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"2. Mal di gola?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"malDiGola"}
						error={errors["malDiGola"]}
						answers={[
							{label: "Presente", value: "true", info: paziente ? "Ho mal di gola" : "Il paziente ha mal di gola"},
							{label: "Assente", value: "A", info: paziente ? "Non ho mal di gola" : "Il paziente non ha mal di gola"},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"3. Presenta difficoltà respiratorie / dispnea?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"dispnea"}
						error={errors["dispnea"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Ho difficoltà a respirare" : "Il paziente presenta difficoltà respiratorie"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non ho difficoltà a respirare" : "Il paziente non  difficoltà respiratorie"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"4. Presenta cefalea / mal di testa?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"cefalea"}
						error={errors["cefalea"]}
						answers={[
							{label: "Presente", value: "true", info: paziente ? "Hai mal di testa" : "Il paziente ha mal di testa"},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non hai mal di testa" : "Il paziente non ha mal di testa"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"5. Ha rilevato un' alterazione del gusto?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"alterazioneGusto"}
						error={errors["alterazioneGusto"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Ho rilevato un alterazione del gusto" : "Il paziente ha rilevato un' alterazione del gusto"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non ho rilevato un alterazione del gusto" : "Il paziente non ha rilevato un' alterazione del gusto"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"6. Ha rilevato un' alterazione dell' olfatto?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"alterazioneOlfatto"}
						error={errors["alterazioneOlfatto"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Ho rilevato un alterazione dell'olfatto" : "Il paziente ha rilevato un' alterazione dell' olfatto"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non ho rilevato un alterazione dell'olfatto" : "Il paziente non ha rilevato un' alterazione dell' olfatto"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"7. Presenta brividi di freddo?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"brividi"}
						error={errors["brividi"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Risento di brividi di freddo" : "Il paziente presenta brividi"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non risento di brividi di freddo" : "Il paziente non presenta brividi"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"8. Presenta dolori muscolari / mialgia?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"mialgia"}
						error={errors["mialgia"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Risento di dolori muscolari" : "Il paziente presenta mialgia"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non risento di dolori muscolari" : "Il paziente non presenta mialgia"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"9. Presenta astenia o inappetenza?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"inappetenza"}
						error={errors["inappetenza"]}
						answers={[
							{label: "Presente", value: "true", info: paziente ? "Non ho appetito" : "Il paziente presenta astenia"},
							{label: "Assente", value: "A", info: paziente ? "Ho appetito" : "Il paziente non presenta astenia"},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"10. Presenta vomito o nausea?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"vomito"}
						error={errors["vomito"]}
						answers={[
							{label: "Presente", value: "true", info: paziente ? "Ho vomito e nausea" : "Il paziente presenta vomito"},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non ho nè vomito nè nausea" : "Il paziente non presenta vomito"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"11. Diarrea?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"diarrea"}
						error={errors["diarrea"]}
						answers={[
							{
								label: "Frequente",
								value: "true",
								info: paziente ? "Effettuo più di 3 scariche al giorno" : " >= 3 scariche al giorno"
							},
							{
								label: "Sporadica",
								value: "0",
								info: paziente ? "Effettuo meno di 3 scariche al giorno" : " < 3 scariche al giorno"
							},
							{label: "Assente", value: "A", info: paziente ? "Non ho la diarrea" : "Il paziente non ha diarrea"},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"12. Raffreddore?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"raffreddore"}
						error={errors["raffreddore"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Ho il raffreddore" : "Il paziente presenta raffreddore"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non ho il raffreddore" : "Il paziente non presenta raffreddore"
							},
							{
								label: "Non dichiarato",
								value: "ND",
								info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							},
						]}
					/>
				</Grid>
				{!paziente && <React.Fragment>
					<Grid item xs={12}>
						<Divider/>
					</Grid>
					<Grid item xs={12}>
						<Typography variant={"subtitle1"} align={"right"}>
							Punteggio: <b style={
							calcPunteggioQuarantena(getValues()) < 2 ? {color: green[600]} :
								calcPunteggioQuarantena(getValues()) < 5 ? {color: amber[600]} :
									calcPunteggioQuarantena(getValues()) < 8 ? {color: red[600]} :
										{color: purple[600]}
						}><span
							style={{fontSize: 40}}>{"  " + calcPunteggioQuarantena(getValues())}</span> / 12</b>
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<Divider/>
					</Grid>
				</React.Fragment>}
			</Grid>
		</React.Fragment>
	);
};
